import { render } from "./popularization.vue?vue&type=template&id=666f34a0&scoped=true"
import script from "./popularization.vue?vue&type=script&lang=js"
export * from "./popularization.vue?vue&type=script&lang=js"

import "./popularization.vue?vue&type=style&index=0&id=666f34a0&scoped=true&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666f34a0"]])

export default __exports__